import styled from 'styled-components/macro';
import { Link } from '@yme/components/Link';
import { colorCoreBlack900Base } from '@yme/tokens/colors';
import { RegularLinkLevel1, RegularLinkStylesCommon } from '@yme/tokens/typography';
import { getTextStyles } from '@yme/utils/styles';
export const LinkButtonStyled = styled(RegularLinkLevel1) `
  white-space: nowrap;
`;
export const LinkStyled = styled(Link) `
  ${getTextStyles('Ubuntu', 400, 16, 24)}

  ${RegularLinkStylesCommon}
  color: ${colorCoreBlack900Base};

  white-space: nowrap;
`;
